import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import Navbar2 from './Navbar2';
import Footer from './Footer/Footer';
import { faAddressBook, faBell, faBox, faCreditCard, faGift, faHeart, faKey, faPlus, faUser, faWallet } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './MyAccount.css';
import { getCurrentUser } from '../services/auth';
import { FaBox, FaCheck, FaShippingFast } from 'react-icons/fa';
import giftCard from '../assets/gift-card.svg';
import giftCard1 from '../assets/giftCard1.svg';
import giftCard2 from '../assets/giftCard2.svg';
import cliqCashWalletBg from '../assets/cliqCashWalletBg.svg';


function MyAccount() {

    const navigate = useNavigate();
    const location = useLocation();

    const [user, setUser] = useState(null);
    const [activeTab, setActiveTab] = useState('orderHistory');
    const [orderTab, setOrderTab] = useState('RecentOrders');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [orders, setOrders] = useState([]);
    const [ordersLoading, setOrdersLoading] = useState(true);
    const [ordersError, setOrdersError] = useState(null);

    const statusConfig = [
        { id: 'Order Placed', label: 'Order Placed', description: 'Your order has been received', icon: <FaBox className="status-icon" /> },
        { id: 'Dispatched', label: 'Dispatched', description: 'Your order has left our warehouse', icon: <FaShippingFast className="status-icon" /> },
        { id: 'In Transit', label: 'In Transit', description: 'Your order is on its way', icon: <FaShippingFast className="status-icon" /> },
        { id: 'Out for Delivery', label: 'Out for Delivery', description: 'Your order will arrive soon', icon: <FaShippingFast className="status-icon" /> },
        { id: 'Delivered', label: 'Delivered', description: 'Your order has arrived', icon: <FaCheck className="status-icon" /> }
    ];

    // Address Book State
    const [addresses, setAddresses] = useState([]);
    const [showAddressForm, setShowAddressForm] = useState(false);
    const [addressForm, setAddressForm] = useState({
        name: '',
        phone: '',
        pincode: '',
        address: '',
        city: '',
        state: '',
        isDefault: false
    });
    const [editingAddress, setEditingAddress] = useState(null);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                setLoading(true);
                const currentUser = getCurrentUser();
                if (!currentUser) {
                    navigate('/home');
                    return;
                }

                if(location.state?.activeTab){
                    setActiveTab(location.state.activeTab);
                }
                const response = await axios.get('http://localhost:3001/auth/me', {
                    withCredentials: true,
                    headers: {
                        'Authorization': `Bearer ${currentUser.token}`
                    }
                });
                setUser(response.data);
                setError(null);

                if (activeTab === 'addressBook') {
                    await fetchAddresses();
                }
                // const ordersResponse = await axios.get('http://localhost:3001/orders', {
                //     withCredentials: true
                // });
                // setOrders(ordersResponse);
            } catch (error) {
                console.error("Error in My Account:", error);
                setError("Failed to load account information");
                navigate('/home');
            } finally {
                setLoading(false);
            }
        };
        fetchUserData();
    }, [navigate, activeTab, location.state]);

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                setOrdersLoading(true);
                const { data } = await axios.get(
                    'http://localhost:3001/orders/my-orders',
                    { withCredentials: true }
                );
                setOrders(data || []);
                setOrdersError(null);
            } catch (error) {
                console.error("Failed to fetch orders:", error);
                setOrdersError(error.response?.data?.error || "Failed to load orders");
            } finally {
                setOrdersLoading(false);
            }
        };

        if (activeTab === 'orderHistory' && orderTab === 'RecentOrders') {
            fetchOrders();
        }
    }, [activeTab, orderTab]);

    const fetchAddresses = async () => {
        try {
            const response = await axios.get('http://localhost:3001/addresses', {
                withCredentials: true,
                headers: {
                    'Authorization': `Bearer ${getCurrentUser()?.token}`
                }
            });
            setAddresses(response.data);
        } catch (error) {
            console.error("Error fetching addresses:", error);
        }
    };

    const handleAddressChange = (e) => {
        setAddressForm({
            ...addressForm,
            [e.target.name]: e.target.value
        });
    };

    const handleSaveAddress = async (e) => {
        e.preventDefault();
        try {
            if (editingAddress) {
                await axios.put(`http://localhost:3001/addresses/${editingAddress._id}`, {
                    ...addressForm,
                    userEmail: user.email
                }, { withCredentials: true });
            } else {
                await axios.post('http://localhost:3001/addresses', {
                    ...addressForm,
                    userEmail: user.email
                }, { withCredentials: true });
            }
            await fetchAddresses();
            resetAddressForm();
        } catch (error) {
            console.error("Error saving address:", error);
        }
    };

    const handleEditAddress = (address) => {
        setEditingAddress(address);
        setAddressForm({
            name: address.name,
            phone: address.phone,
            pincode: address.pincode,
            address: address.address,
            city: address.city,
            state: address.state,
            isDefault: address.isDefault
        });
        setShowAddressForm(true);
    };

    const handleDeleteAddress = async (addressId) => {
        if (window.confirm('Are you sure you want to delete this address?')) {
            try {
                await axios.delete(`http://localhost:3001/addresses/${addressId}`, {
                    withCredentials: true
                });
                await fetchAddresses();
            } catch (error) {
                console.error("Error deleting address:", error);
            }
        }
    };

    const resetAddressForm = () => {
        setEditingAddress(null);
        setShowAddressForm(false);
        setAddressForm({
            name: '',
            phone: '',
            pincode: '',
            address: '',
            city: '',
            state: '',
            isDefault: false
        });
    };



    if (!user && !loading) {
        return (
            <>
                <Navbar />
                <div className="container text-center my-5">
                    <div className="alert alert-warning">
                        Please login to view your account
                    </div>
                </div>
                <Footer />
            </>
        );
    }

    const menuItems = [
        { id: 'wishlist', label: 'My Wishlist', icon: faHeart, path: '/wishlist' },
        { id: 'orderHistory', label: 'Order History', icon: faBox },
        { id: 'newPass', label: 'NewPass', icon: faKey },
        { id: 'addressBook', label: 'Address Book', icon: faAddressBook },
        { id: 'payments', label: 'Saved Payments', icon: faCreditCard },
        { id: 'alerts', label: 'Alerts & Coupons', icon: faBell },
        { id: 'giftCard', label: 'Gift Card', icon: faGift },
        { id: 'cliqCash', label: 'CLiQ Cash', icon: faWallet },
        { id: 'notifications', label: 'Manage Notifications', icon: faBell },
        { id: 'profile', label: 'Profile', icon: faUser }
    ];

    const renderContent = () => {
        if (loading) return <div className="account-content">Loading...</div>;
        if (error) return <div className="account-content text-danger">{error}</div>;

        switch (activeTab) {
            case 'orderHistory':
                return (
                    <div className="account-content">
                        <div className="order-history-tabs">
                            {['RecentOrders', 'MyReviews', 'UsefulLinks', 'Alerts', 'Coupons'].map(tab => (
                                <button
                                    key={tab}
                                    className={`order-history-tab ${orderTab === tab ? 'active' : ''}`}
                                    onClick={() => setOrderTab(tab)}
                                >
                                    {tab.split(/(?=[A-Z])/).join(' ')}
                                </button>
                            ))}
                        </div>

                        {orderTab === 'RecentOrders' && (
                            <div className="recent-orders">
                                {ordersLoading ? (
                                    <div className="loading-spinner">Loading orders...</div>
                                ) : ordersError ? (
                                    <div className="alert alert-danger">{ordersError}</div>
                                ) : orders.length === 0 ? (
                                    <div className="no-orders">
                                        <h5>No Recent Orders</h5>
                                        <p>You haven't placed any orders yet.</p>
                                        <button
                                            className="btn btn-primary mt-2"
                                            onClick={() => navigate('/home')}
                                        >
                                            Shop Now
                                        </button>
                                    </div>
                                ) : (
                                    <div className="orders-grid">
                                        {orders.map(order => {
                                            const currentStatusIndex = statusConfig.findIndex(s => s.id === order.trackingStatus);

                                            return (
                                                <div key={order._id} className="order-card">
                                                    <div className="order-header">
                                                        <span className="order-id">Order #{order._id.slice(-8).toUpperCase()}</span>
                                                        <span className={`status-badge ${order.trackingStatus.toLowerCase().replace(' ', '-')}`}>
                                                            {order.trackingStatus}
                                                        </span>
                                                    </div>

                                                    <div className="order-date">
                                                        {new Date(order.createdAt).toLocaleDateString()}
                                                    </div>

                                                    <div className="order-total">
                                                        ₹{order.total.toFixed(2)}
                                                    </div>

                                                    <div className="order-items-preview">
                                                        {order.items.slice(0, 2).map((item, index) => (
                                                            <div key={index} className="order-item-preview">
                                                                <img
                                                                    src={item.image}
                                                                    alt={item.name}
                                                                    className="item-thumbnail"
                                                                />
                                                                <span className="item-name">{item.name}</span>
                                                            </div>
                                                        ))}
                                                        {order.items.length > 2 && (
                                                            <div className="more-items">+{order.items.length - 2} more</div>
                                                        )}
                                                    </div>

                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={() => navigate('/track-order', { state: { orderId: order._id } })}
                                                    >
                                                        Track Order
                                                    </button>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        )}

                        {orderTab === 'MyReviews' && (
                            <div className="my-reviews">
                                <h5>My Reviews</h5>
                                <p>No reviews available.</p>
                            </div>
                        )}

                        {orderTab === 'UsefulLinks' && (
                            <div className="useful-links">
                                <h5>Useful Links</h5>
                                <p>No links available.</p>
                            </div>
                        )}

                        {orderTab === 'Alerts' && (
                            <div className="alerts">
                                <h5>Alerts</h5>
                                <p>No alerts available.</p>
                            </div>
                        )}

                        {orderTab === 'Coupons' && (
                            <div className="coupons">
                                <h5>Coupons</h5>
                                <p>No coupons available.</p>
                            </div>
                        )}
                    </div>
                );

            case 'addressBook':
                return (
                    <div className="account-content">
                        <div className="address-book-header">
                            <h3>Saved Addresses</h3>
                            <button
                                className="btn btn-primary"
                                onClick={() => {
                                    setEditingAddress(null);
                                    setShowAddressForm(true);
                                }}
                            >
                                <FontAwesomeIcon icon={faPlus} className='me-2' />
                                Add New Address
                            </button>
                        </div>

                        {showAddressForm ? (
                            <div className="address-form-container">
                                <h4>{editingAddress ? 'Edit Address' : 'Add New Address'}</h4>
                                <form onSubmit={handleSaveAddress}>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Full Name</label>
                                            <input
                                                type="text"
                                                name="name"
                                                value={addressForm.name}
                                                onChange={handleAddressChange}
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Phone Number</label>
                                            <input
                                                type="tel"
                                                name="phone"
                                                value={addressForm.phone}
                                                onChange={handleAddressChange}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label>Complete Address</label>
                                        <textarea
                                            name="address"
                                            value={addressForm.address}
                                            onChange={handleAddressChange}
                                            required
                                        />
                                    </div>

                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Pincode</label>
                                            <input
                                                type="text"
                                                name="pincode"
                                                value={addressForm.pincode}
                                                onChange={handleAddressChange}
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>City</label>
                                            <input
                                                type="text"
                                                name="city"
                                                value={addressForm.city}
                                                onChange={handleAddressChange}
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>State</label>
                                            <input
                                                type="text"
                                                name="state"
                                                value={addressForm.state}
                                                onChange={handleAddressChange}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="form-check">
                                        <input
                                            type="checkbox"
                                            id="isDefault"
                                            checked={addressForm.isDefault}
                                            onChange={(e) => setAddressForm({
                                                ...addressForm,
                                                isDefault: e.target.checked
                                            })}
                                        />
                                        <label htmlFor="isDefault">Set as default address</label>
                                    </div>

                                    <div className="form-actions">
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary"
                                            onClick={resetAddressForm}
                                        >
                                            Cancel
                                        </button>
                                        <button type="submit" className="btn btn-primary">
                                            Save Address
                                        </button>
                                    </div>
                                </form>
                            </div>
                        ) : (
                            <div className="address-list">
                                {addresses.length > 0 ? (
                                    addresses.map(address => (
                                        <div key={address._id} className="address-card">
                                            <div className="address-details">
                                                <h5>
                                                    {address.name}
                                                    {address.isDefault && <span className="badge bg-primary ms-2">Default</span>}
                                                </h5>
                                                <p>{address.address}</p>
                                                <p>{address.city}, {address.state} - {address.pincode}</p>
                                                <p>Phone: {address.phone}</p>
                                            </div>

                                            <div className="address-actions">
                                                <button
                                                    className="btn btn-sm btn-outline-primary me-2"
                                                    onClick={() => handleEditAddress(address)}
                                                >
                                                    Edit
                                                </button>
                                                <button
                                                    className="btn btn-sm btn-outline-danger"
                                                    onClick={() => handleDeleteAddress(address._id)}
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="no-addresses text-center py-4">
                                        <h5>No Saved Addresses</h5>
                                        <p>You haven't saved any addresses yet.</p>
                                        <button
                                            className="btn btn-primary mt-2"
                                            onClick={() => setShowAddressForm(true)}
                                        >
                                            <FontAwesomeIcon icon={faPlus} className="me-2" />
                                            Add New Address
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                );

            case 'cliqCash':
                return (
                    <div className='cliqCash-content'>
                        <div className="cliq-cash-wallet">
                            <img
                                src={cliqCashWalletBg}
                                alt="cliq-cash-wallet"
                                className='wallet-img'
                            />
                            <div className="wallet-text-content">
                                <div className="content-row">
                                    <div className="left-section">
                                        <div className="wallet-title">CLiQ Cash Wallet</div>
                                        <div className="balance-label">Total Available Balance</div>
                                        <div className="balance-amount">₹150.00</div>
                                    </div>
                                    <div className="vertical-divider"></div>
                                    <div className="right-section">
                                        <div className="description">
                                            A quick and convenient way for faster checkout and refund.
                                            <span className="know-more"> Know More</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="expiry-notice">
                                    ₹50 CLiQ Cash will expire on {getFutureDate(4)}
                                </div>
                            </div>
                        </div>

                        <div className="gift-card">
                            <h3 className="gift-card-heading">Gift Cards</h3>
                            <div className="horizontal-divider"></div>

                            <div className="gift-card-item">
                                <img
                                    src={giftCard1}
                                    alt="Gift Card 1"
                                    className="gift-card-image"
                                />
                                <div className="gift-card-details">
                                    <div className="gift-card-name">Add Gift Card Balance</div>
                                    <div className="gift-card-balance">Received Gift Card from someone</div>
                                </div>
                                <button className="cliqCash-gift-card-button">Add It Here</button>
                            </div>

                            <div className="horizontal-divider"></div>

                            <div className="gift-card-item">
                                <img
                                    src={giftCard2}
                                    alt="Gift Card 2"
                                    className="gift-card-image"
                                />
                                <div className="gift-card-details">
                                    <div className="gift-card-name">Send Gift Card</div>
                                    <div className="gift-card-balance">Send Gift Card to someone</div>
                                </div>
                                <button className="cliqCash-gift-card-button">Buy gift card</button>
                            </div>
                        </div>
                    </div>
                );

            case 'giftCard':
                return (
                    <div className="cliq-gift-card">
                        <div className="send-gift-card">
                            <div className="gift-card-header">
                                <h2>CLiQ Gift Card</h2>
                                <h6>Experience the joy of <strong>gifting,</strong> delivered straight to the <strong>inbox</strong></h6>
                            </div>
                            <img src={giftCard} alt="gift-image" className='gift-image' />
                            <button className="gift-card-button">Send a Gift Card</button>
                        </div>

                        <div className="card-value">
                            <h4 className="card-value-title">Pick A Popular Card Value</h4>
                            <p className="card-value-subtitle">Choose from any of the value below to buy a quick Gift Card or choose another value</p>
                            <div className="card-value-options">
                                <button className="value-option">₹500</button>
                                <button className="value-option">₹1000</button>
                                <button className="value-option">₹2000</button>
                            </div>
                        </div>

                        <div className="giftCard-gift-card">
                            <h3 className="giftCard-gift-card-heading">Received a Gift Card ?</h3>
                            <div className="horizontal-divider"></div>

                            <div className="giftCard-gift-card-item">
                                <img
                                    src={giftCard1}
                                    alt="Gift Card 1"
                                    className="giftCard-gift-card-image"
                                />
                                <div className="giftCard-gift-card-details">
                                    <div className="giftCard-gift-card-name">Add It To Your Account</div>
                                    <div className="giftCard-gift-card-balance">Amount will be added to the CLiQ Cash wallet</div>
                                </div>
                                <button className="giftCard-gift-card-button">Add It Here</button>
                            </div>

                            <div className="horizontal-divider"></div>

                            <div className="giftCard-gift-card-item">
                                <img
                                    src={giftCard2}
                                    alt="Gift Card 2"
                                    className="giftCard-gift-card-image"
                                />
                                <div className="giftCard-gift-card-details">
                                    <div className="giftCard-gift-card-name">Track Your Gift Balance</div>
                                    <div className="giftCard-gift-card-balance">Stay updated about your gift card usage</div>
                                </div>
                                <button className="giftCard-gift-card-button">Track Balance</button>
                            </div>
                        </div>
                    </div>
                );

            default:
                return (
                    <div className="account-content">
                        <h4>{menuItems.find(item => item.id === activeTab)?.label}</h4>
                        <div className="alert alert-info">
                            {menuItems.find(item => item.id === activeTab)?.label} content will be displayed here
                        </div>
                    </div>
                );
        }
    };

    function getFutureDate(days) {
        const futureDate = new Date();
        futureDate.setDate(futureDate.getDate() + days);
        return futureDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    }

    return (
        <>
            <Navbar />
            <div className="sticky-navbar">
                <Navbar2 />
            </div>

            <div className="container my-account-container">
                <div className="row">
                    {/* Left Sidebar */}
                    <div className="col-md-3">
                        <div className="account-sidebar card border-0">
                            <div className="card-header">
                                <h5 className='mb-0'>Menu</h5>
                            </div>
                            <div className="list-group list-group-flush">
                                {menuItems.map(item => (
                                    <button
                                        key={item.id}
                                        className={`list-group-item list-group-item-action ${activeTab === item.id ? 'active' : ''}py-3 px-4`}
                                        onClick={() => item.path ? navigate(item.path) : setActiveTab(item.id)}
                                    >
                                        <FontAwesomeIcon icon={item.icon} className='me-3' />
                                        {item.label}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Main Content */}
                    <div className="col-md-7">
                        {renderContent()}
                    </div>

                    {/* Right User Card */}
                    <div className="col-md-2">
                        <div className="card user-card">
                            <div className="card-body text-center">
                                <div className="user-avatar mb-3">
                                    <div className="avatar-circle">
                                        {user?.name?.charAt(0).toUpperCase()}
                                    </div>
                                </div>
                                <h5>{user?.name}</h5>
                                <p className="text-muted">{user?.email}</p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-margin">
                <Footer />
            </div>
        </>
    );
}

export default MyAccount